import { useMutation, useQuery } from '@tanstack/vue-query';
import { MaybeRef } from '@/types/utils';
import { DatePeriod } from '@/types/common/dateRange.model';
import ReportsCustomerService, {
  GetCourierCustomersPayload,
} from '@/services/reports/reports.customer.service';
import { computed, unref } from 'vue';
import { useToast } from '../useToast';
import axios from 'axios';

export const useReportCustomers = () => {
  const toast = useToast();
  const useGetWarehouseCustomers = (period: MaybeRef<DatePeriod | null>) =>
    useQuery(['warehouse', 'customers', period], async () => {
      const query = unref(period);
      if (!query) return [];
      const {
        data: { data },
      } = await ReportsCustomerService.getWarehouseCustomers(query);
      return data;
    });
  const useGetCommissionCustomers = (period: MaybeRef<DatePeriod | null>) =>
    useQuery(
      ['commission', 'customers', period],
      async () => {
        const query = unref(period);
        if (!query) return;
        const {
          data: { data },
        } = await ReportsCustomerService.getCommissionCustomers(query);
        return data;
      },
      {
        enabled: computed(() => !!unref(period)),
      }
    );

  const useGetCourierCustomers = () => {
    return useMutation(async (payload: GetCourierCustomersPayload) => {
      try {
        const {
          data: { data },
        } = await ReportsCustomerService.getCourierCustomers(payload);
        return data;
      } catch (error: any) {
        toast.info(error?.response?.data || 'Failed to fetch customers');
      }
    });
  };

  const useGetWarehouseCourierCustomers = (url: string) => {
    return useMutation((payload: GetCourierCustomersPayload) =>
      axios.post(url, payload).then((response) => response.data)
    );
  };

  return {
    useGetCommissionCustomers,
    useGetWarehouseCustomers,
    useGetCourierCustomers,
    useGetWarehouseCourierCustomers,
  };
};
